import { AT_ISARETLERI, OZYINELEMELI_OLCUT, ocakCiktisi, } from './email-mask-atil';
/**
 * ATIL MADDE TARAYICILARI VE LİSTESİ — `email-mask-atil.ts`in İKİNCİ YARISI.
 *
 * NEDEN AYRI (dokuzuncu dalga, 17.09.2026): tek dosya 632 satıra çıktı, kaynak
 * tavanı 500 (`file-size-ceiling.guard.spec`). Ayrım kavramsaldır: `email-mask-atil.ts`
 * "atıl madde NEDİR ve ocak kararı NASIL verilir" sorusunu cevaplar (tip,
 * ölçüt, `ocakCiktisi`), BURASI "hangi metin parçası atıl maddedir" sorusunu
 * (desenler, dengeli tarayıcılar, madde listesi).
 */
/* ==========================================================================
 * DESENLİ MADDELER — CDATA/bildirim, HTML/XML etiketi, ANSI CSI.
 *
 * İlk iki aile İÇ İÇE GEÇEMEZ (`[^<>]*` sınıfı `<` göremez), yani desen daima
 * EN İÇTEKİ ocağı eşler ve dış ocaklar sabit nokta turlarında sırayla açılır.
 * Ocak kararı bu yüzden desenli ailede de doğru sırayla verilir: içteki yem
 * önce SÖKÜLÜR, dıştaki ocak sonra değerlendirilir.
 * ========================================================================== */
/*
 * HTML ETİKETİ: `<ali@ornek.com>` BU DESENE GİRMEZ ve bu kritik bir ayrımdır —
 * SMTP metninin en yaygın biçimi açılı ayraçlı adrestir. Etiket ADI `@`
 * taşıyamaz; `@` geldiği anda eşleşme düşer.
 *
 * AD SINIFI XML `Name`DİR, HTML ETİKET LİSTESİ DEĞİL: `<ns:tag>` (SOAP/XML
 * gövdesi), `<1x>` (rakamla başlayan ad) ve boş `<>`/`</>` biçimi de etikettir;
 * üçü de panelde adres olarak okunuyordu.
 *
 * BİLİNEN MALİYET: `<LF>`, `<CRLF>`, `<SP>` gibi SMTP yer tutucuları da etiket
 * biçimindedir ve sökülürler. Maliyet yalnız metinde ADRES varken görünür.
 *
 * `!`/`?` ile başlayan biçim BU MADDEYE GİRMEZ: onlar `isaretleme-bildirimi`
 * maddesinindir. Ayrım bilinçlidir — bir maddenin yükünü başka bir maddenin
 * taşıması kapıyı KÖR eder (7. AYAK bunu madde madde ölçer).
 */
const HTML_ETIKETI = /<(\/?(?:[A-Za-z0-9_:][A-Za-z0-9_:.-]*(?:\s[^<>]*)?\/?)?)>/g;
/*
 * İŞARETLEME BİLDİRİMİ — CDATA · İŞLEM YÖNERGESİ · DOCTYPE.
 *
 * `<![CDATA[x]]>` ve `<?xml x?>` etiket DEĞİLDİR (etiket adı harfle başlar),
 * bu yüzden `HTML_ETIKETI`ne takılmıyorlardı. Aile tek desende kapanır:
 * `<` + `!`/`?` + ilk `>`. Adresin kendi açılı ayracı (`<ali@ornek.com>`) bu
 * desene GİRMEZ — ikinci karakter harftir.
 *
 * `(?!--)` AYAĞI TELAFİYİ ENGELLER: bu desen `--` dışlaması olmadan `<!---->`yi
 * de yutuyordu, yani `html-yorumu` maddesi sökülse bile sızıntı GERİ GELMİYORDU.
 */
const ISARETLEME_BILDIRIMI = /<[!?](?!--)([^<>]*)>/g;
/*
 * ANSI CSI DİZİSİ — ADIM KUSURU KENDİSİ ÜRETİYORDU (QA, dokuzuncu dalga).
 *
 * ESC bir `\p{Cc}`dir ve `gorunmezleriSok` onu TEK BAŞINA siliyordu; geriye
 * `[31m` / `[0m` kalıyor ve bu YENİ BİR ENGEL oluyordu:
 *   `qd908 ESC[31m @ ESC[0m ornek.com` → AYNEN dönüyordu,
 *   `qa08 ESC[0m @ornek.com`           → `qa08[[eposta]` (yerel ad sızdı).
 * Sağlayıcı günlükleri renkli yazar; dizi yapısal olarak atıldır ve
 * `AtilMadde`nin tanımına girer.
 *
 * SON BAYT SINIFI `[A-~]`DİR, `[@-~]` DEĞİL ve SEÇMELİDİR. Gerekçe fail-closed:
 * CSI'nın gerçek son bayt kümesi `@`yi de içerir (ICH), yani `ali ESC[ @ornek.com`
 * yazımında dizi GERÇEK `@`yi yutar ve maskeleme sessizce fail-OPEN olurdu.
 * `@` dışarıda bırakılınca dizi sonlandırıcısız kalır, seçmeli son bayt onu
 * yine de söker ve `@` metinde durur (`email-mask.spec.ts` bunu ölçer).
 */
// eslint-disable-next-line no-control-regex -- ESC dizinin TANIMIDIR; kural onu arar.
const ANSI_CSI = /\u001b\[[0-9;:<=>?]*[ -/]*[A-~]?/g;
/*
 * ÖKSÜZ AÇILI AYRAÇ — HİÇBİR İŞARETLEME YAPISINI BAŞLATAMAYAN `<`.
 *
 * QA'nın yedinci yükü (`<!-- qd907<!--@--><@ornek.com -->`) yalnız bu yüzden
 * ham kalıyordu: iç yem yorumu sökülünce geriye `qd907<@ornek.com` kalıyor ve
 * `<` yerel ad ile `@` arasına düşüyordu. Ayraç KAPANMAMIŞ bir yapının
 * artığıdır — ardından harf, rakam, `_`, `:`, `!`, `?`, `/` ya da `>` gelmiyorsa
 * ne etiket ne bildirim ne yorum başlatabilir, yani hiçbir okumada anlam
 * taşımaz. Adres karakteri de değildir.
 *
 * KAPSAM BİLEREK DARDIR: yalnız `<`, yalnız SÖKÜM kipinde. `>` için karşılığı
 * YOKTUR (bir `>` her zaman bir yapının kapanışı olabilir) ve `ayir`/`secici`
 * okumaları ayracı KORUR — bu okumalar yapıyı bozmadan açar. Maliyet ancak
 * metinde adres VARKEN çıktıya ulaşır.
 */
const OKSUZ_ACILI = /<(?![A-Za-z0-9_:!?/>])/g;
/** Desenli madde → söküm fonksiyonu. `lastIndex` her çağrıda sıfırlanır. */
function desenliSok(desen) {
    return (metin) => {
        desen.lastIndex = 0;
        return metin.replace(desen, '');
    };
}
/**
 * Desenli madde → AYIRICIYA İNDİRGEME fonksiyonu.
 *
 * Desenin BİRİNCİ yakalama grubu maddenin TAŞIDIĞI metindir; sınırlayıcılar
 * (`<`, `>`, `<!`, `?`) boşluğa iner, grup aynen kalır. Grup yoksa madde boş
 * bir ayırıcıya iner — bilgi yok edilmez, yalnız sınır silinir.
 */
function desenliAyir(desen) {
    return (metin) => {
        desen.lastIndex = 0;
        return metin.replace(desen, (_tam, ic) => ` ${ic ?? ''} `);
    };
}
/**
 * Desenli madde → OCAK BAZLI SEÇİCİ kip.
 *
 * `matchAll` deseni KLONLAR, yani özyinelemeli çağrı dıştaki taramanın
 * `lastIndex`ini bozmaz. Kendi kendine girişli bir `replace` bu güvenceyi
 * vermez ve sessizce eşleşme atlardı.
 */
function desenliSeciciKos(desen, metin, maddeler, olcut) {
    desen.lastIndex = 0;
    const eslesmeler = [...metin.matchAll(desen)];
    if (eslesmeler.length === 0)
        return metin;
    let sonuc = '';
    let index = 0;
    for (const eslesme of eslesmeler) {
        const bas = eslesme.index ?? 0;
        sonuc += metin.slice(index, bas);
        const ic = eslesme[1];
        sonuc +=
            ic === undefined
                ? ' '
                : ocakCiktisi(ic, 'secici', maddeler, (alt) => desenliSeciciKos(desen, alt, maddeler, olcut), ' ', olcut);
        index = bas + eslesme[0].length;
    }
    return sonuc + metin.slice(index);
}
function desenliSecici(desen, olcut) {
    return (metin, maddeler = ATIL_MADDELER) => desenliSeciciKos(desen, metin, maddeler, olcut);
}
/* ==========================================================================
 * TARAYICILI MADDELER — HTML YORUMU ve RFC 5322 YORUMU.
 *
 * İKİSİ DE İÇ İÇE GEÇEBİLİR ve desen dengeli sayamaz. RFC 5322 yorumunun iç
 * içeliği dilin kendi gramerindedir (`ccontent = ctext / quoted-pair / comment`).
 * HTML yorumu için iç içelik WHATWG'de tanımlı DEĞİLDİR (ilk `-->` kapatır) ama
 * metin bir SAĞLAYICI GÜNLÜĞÜDÜR, tarayıcı değil: `<!-- qd <!-- @ --> a@b.co -->`
 * dizgesinde personel `qd`yi de `a@b.co`yu da GÖZLE okur. Tarayıcı bu yüzden
 * DENGELİ okumayı dener, dengeli kapanış yoksa İLK `-->`e düşer (eski davranış).
 * ========================================================================== */
const YORUM_AC = '<!--';
const YORUM_KAPA = '-->';
/** `bas` konumundaki `<!--` için dengeli kapanış; yoksa İLK `-->`, o da yoksa -1. */
function yorumKapanisi(metin, bas) {
    let derinlik = 1;
    let ilkKapanis = -1;
    let index = bas + YORUM_AC.length;
    while (index < metin.length) {
        if (metin.startsWith(YORUM_KAPA, index)) {
            if (ilkKapanis < 0)
                ilkKapanis = index;
            derinlik -= 1;
            if (derinlik === 0)
                return index;
            index += YORUM_KAPA.length;
            continue;
        }
        if (metin.startsWith(YORUM_AC, index)) {
            derinlik += 1;
            index += YORUM_AC.length;
            continue;
        }
        index += 1;
    }
    return ilkKapanis;
}
function htmlYorumu(metin, kip, maddeler, olcut) {
    /* HIZLI ÇIKIŞ: açılış jetonu yoksa tarayıcı boşuna gezmez (21. AYAK ölçer). */
    if (!metin.includes(YORUM_AC))
        return metin;
    let sonuc = '';
    let index = 0;
    while (index < metin.length) {
        if (!metin.startsWith(YORUM_AC, index)) {
            sonuc += metin[index];
            index += 1;
            continue;
        }
        const kapanis = yorumKapanisi(metin, index);
        if (kapanis < 0) {
            sonuc += metin[index];
            index += 1;
            continue;
        }
        const icerik = metin.slice(index + YORUM_AC.length, kapanis);
        sonuc += ocakCiktisi(icerik, kip, maddeler, (alt) => htmlYorumu(alt, kip, maddeler, olcut), '', olcut);
        index = kapanis + YORUM_KAPA.length;
    }
    return sonuc;
}
/*
 * RFC 5322 §3.2.2 yorumu adresin İÇİNDE, `@`nin iki yanında serbesttir
 * (`local(yorum)@(yorum)domain`) ve Postfix/Exim bunu gerçekten yazar.
 * SÖKÜM `@`YE ÇAPALIDIR: serbest parantez SÖKÜLMEZ, çünkü sağlayıcı teşhis
 * metninin günlük biçimi parantezlidir (`status=deferred (connect timed out)`)
 * ve onu söken bir kural tanı yüzeyini bozardı (12. AYAK bunu asertler).
 */
/** `bas` konumundaki `(` için dengeli kapanış indeksi; yoksa -1. */
function dengeliKapanis(metin, bas) {
    let derinlik = 0;
    for (let index = bas; index < metin.length; index += 1) {
        const harf = metin[index];
        // Yorum ham satır sonu taşımaz: katlama zaten açılmış olur.
        if (harf === '\n' || harf === '\r')
            return -1;
        if (harf === '(')
            derinlik += 1;
        else if (harf === ')') {
            derinlik -= 1;
            if (derinlik === 0)
                return index;
        }
    }
    return -1;
}
/**
 * `harf` bir AT işareti mi?
 *
 * `AT_ISARETLERI.includes(harf)` TEK BAŞINA KULLANILAMAZ: metnin başında ya da
 * sonunda komşu harf BOŞ DİZEDİR ve `''` her dizenin alt dizesidir — yani
 * `includes('')` HER ZAMAN `true` döner. Kapı bunu ölçtü (12. AYAK): satır
 * sonundaki `status=deferred (connect timed out)` yorumu `@` komşusu sanılıp
 * SİLİNİYORDU, yani teşhis metni bozuluyordu. Boş dize açıkça elenir.
 */
function atMi(harf) {
    return harf.length === 1 && AT_ISARETLERI.includes(harf);
}
function sonAnlamliHarf(metin) {
    const kirpik = metin.replace(/[ \t]+$/u, '');
    return kirpik.charAt(kirpik.length - 1);
}
function ilkAnlamliHarf(metin, bas) {
    let index = bas;
    while (index < metin.length && (metin[index] === ' ' || metin[index] === '\t'))
        index += 1;
    return metin.charAt(index);
}
function rfc5322Yorumu(metin, kip, maddeler, olcut) {
    /*
     * HIZLI ÇIKIŞ — ÖLÇÜLDÜ. Dengeli tarayıcı metni karakter karakter gezer ve
     * dizgeyi yeniden kurar; parantezsiz metinde bu iş BOŞUNADIR. Girdi
     * tavanındaki en kötü hâl 12,96 → 20,6 ms'ye çıkmıştı; bu satırla 15,0 ms.
     */
    if (!metin.includes('('))
        return metin;
    let sonuc = '';
    let index = 0;
    while (index < metin.length) {
        if (metin[index] !== '(') {
            sonuc += metin[index];
            index += 1;
            continue;
        }
        const kapanis = dengeliKapanis(metin, index);
        if (kapanis < 0) {
            sonuc += metin[index];
            index += 1;
            continue;
        }
        if (atMi(sonAnlamliHarf(sonuc)) || atMi(ilkAnlamliHarf(metin, kapanis + 1))) {
            const icerik = metin.slice(index + 1, kapanis);
            sonuc += ocakCiktisi(icerik, kip, maddeler, (alt) => rfc5322Yorumu(alt, kip, maddeler, olcut), '', olcut);
            index = kapanis + 1;
            continue;
        }
        /*
         * ÇAPASIZ PARANTEZ KORUNUR AMA İÇİNE GİRİLİR (dokuzuncu dalga, 17.09.2026).
         *
         * Eski hâl `slice` ile bütün ocağı ATLIYORDU ve QA bunu doğrudan kullandı:
         *   `status=bounced (host said: 550 qd905((sender [eposta]))@ornek.com …)`
         * Dıştaki parantez çapasızdır (Postfix'in GÜNLÜK biçimi), yani atlanıyor ve
         * içindeki ÇAPALI ocak (`((…))@`) hiç görülmüyordu — metin bütünüyle ham
         * dönüyordu. Parantezin kendisi TEŞHİS metnidir ve yerinde kalır; içeriği
         * özyinelemeli taranır.
         */
        const icerik = metin.slice(index + 1, kapanis);
        sonuc += `(${rfc5322Yorumu(icerik, kip, maddeler, olcut)})`;
        index = kapanis + 1;
    }
    return sonuc;
}
function tarayiciliMadde(tarayici, kip, olcut) {
    return (metin, maddeler = ATIL_MADDELER) => tarayici(metin, kip, maddeler, olcut);
}
/**
 * ATIL MADDE LİSTESİNİ ÖLÇÜTLE KURAR.
 *
 * Üretimde tek bir çağrı vardır (`ATIL_MADDELER`). Fabrika, kapının ölçütü
 * MUTASYONA uğratabilmesi içindir: `atilMaddeler(TEK_ADIMLIK_OLCUT)` sekizinci
 * dalganın kararını geri koyar ve yem sızıntısının GERİ GELDİĞİ ölçülür.
 */
export function atilMaddeler(olcut = OZYINELEMELI_OLCUT) {
    return [
        {
            ad: 'html-yorumu',
            kapsayici: true,
            sok: tarayiciliMadde(htmlYorumu, 'sok', olcut),
            ayir: tarayiciliMadde(htmlYorumu, 'ayir', olcut),
            secici: tarayiciliMadde(htmlYorumu, 'secici', olcut),
            ornek: 'qauser1<!---->@ornek.com',
            icerdeAdres: '550 failed <!-- recipient: qauser1@ornek.com --> see log',
            sar: (icerik) => `<!-- ${icerik} -->`,
            kurban: 'qauser1',
        },
        {
            ad: 'isaretleme-bildirimi',
            kapsayici: true,
            sok: desenliSok(ISARETLEME_BILDIRIMI),
            ayir: desenliAyir(ISARETLEME_BILDIRIMI),
            secici: desenliSecici(ISARETLEME_BILDIRIMI, olcut),
            ornek: 'qauser6<![CDATA[x]]>@ornek.com',
            icerdeAdres: '550 <![CDATA[qauser6@ornek.com]]> rejected',
            sar: (icerik) => `<![CDATA[${icerik}]]>`,
            kurban: 'qauser6',
        },
        {
            ad: 'html-etiketi',
            kapsayici: true,
            // Etiket sökülür, ardından ÖKSÜZ açılı ayraç da düşer (bkz. `OKSUZ_ACILI`).
            sok: (metin) => {
                OKSUZ_ACILI.lastIndex = 0;
                return desenliSok(HTML_ETIKETI)(metin).replace(OKSUZ_ACILI, '');
            },
            ayir: desenliAyir(HTML_ETIKETI),
            secici: desenliSecici(HTML_ETIKETI, olcut),
            ornek: '<span>qauser2</span>@ornek.com',
            icerdeAdres: '<input type="email" value="qauser2@ornek.com" /> 550 blocked',
            // Etiket İÇERİĞİ öznitelik değeridir: sarmalayan biçim budur.
            sar: (icerik) => `<div title="${icerik}"></div>`,
            kurban: 'qauser2',
        },
        {
            ad: 'rfc5322-yorumu',
            kapsayici: true,
            sok: tarayiciliMadde(rfc5322Yorumu, 'sok', olcut),
            ayir: tarayiciliMadde(rfc5322Yorumu, 'ayir', olcut),
            secici: tarayiciliMadde(rfc5322Yorumu, 'secici', olcut),
            ornek: '550 <qauser3@((yorum))ornek.com> rejected',
            icerdeAdres: 'status=deferred a@ (host said: 550 qauser3@ornek.com rejected)',
            // Söküm `@`ye ÇAPALIDIR: sarmalayan biçim çapayı da taşımak zorunda.
            sar: (icerik) => `a@ (host said: ${icerik})`,
            kurban: 'qauser3',
        },
        {
            ad: 'ansi-csi',
            // KAP DEĞİL: taşıdığı metin yoktur, tek başına bir jetondur (bkz. `kapsayici`).
            kapsayici: false,
            sok: desenliSok(ANSI_CSI),
            ayir: desenliAyir(ANSI_CSI),
            secici: desenliAyir(ANSI_CSI),
            ornek: 'qauser9\u001b[31m@\u001b[0mornek.com',
            icerdeAdres: '550 \u001b[1mqauser9@ornek.com\u001b[0m rejected',
            sar: (icerik) => `\u001b[1m${icerik}\u001b[0m`,
            kurban: 'qauser9',
        },
    ];
}
export const ATIL_MADDELER = atilMaddeler();
/**
 * HIZLI YOLLARIN KAYDI — "ispatlı no-op" iddiası SAYILABİLİR hâle gelir.
 *
 * İki tarayıcı da bir JETONUN YOKLUĞUNA dayanarak metni olduğu gibi döndürür
 * (`(` ve `<!--`). İddia bugün doğrudur ama bir VARSAYIMDIR: tarayıcı yarın
 * genişletilirse atlama sessizce KÖR kalır. `email-mask-kesim.spec.ts` 21. AYAK
 * bu tabloyu sürer ve AYRICA bu dosyadaki `includes` atlamalarını SAYAR —
 * kaydedilmemiş üçüncü bir hızlı yol eklenirse KIRILIR.
 *
 * (Üçüncü hızlı yol `boslugaIndirge`dedir ve desene çapalıdır; 21. AYAK onu
 * kendi ayağında, `AT_BITISIK_BOSLUK` üzerinden ölçer.)
 */
export const ATIL_HIZLI_YOLLARI = [
    { madde: 'html-yorumu', jeton: YORUM_AC },
    { madde: 'rfc5322-yorumu', jeton: '(' },
];
/** Kapsayıcı olmayan (jeton) maddeler — 6b. AYAK'ın ENUMERE ettiği muafiyet. */
export const JETON_MADDELER = ATIL_MADDELER.filter((madde) => !madde.kapsayici).map((madde) => madde.ad);
//# sourceMappingURL=email-mask-tarayici.js.map